/* ============================================================
   WIN.ERALS Redesign — gemeinsames Verhalten
   Quelle: redesign-system/index.html (UI-Export).
   Kleine, robuste Bausteine; überleben shopify:section:load.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Header: Blur-Sticky + schrumpfendes Logo ---------- */
  var lastScrolled = null;
  function onScroll() {
    var on = window.scrollY > 8;
    if (on !== lastScrolled) {
      lastScrolled = on;
      document.body.classList.toggle('wr-scrolled', on);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Akkordeons (FAQ, Footer, Drawer, PDP) ----------
     Markup: <div class="wr-acc__item"><button data-wr-acc>…</button>
             <div class="wr-acc__body"><div class="wr-acc__inner">…</div></div></div> */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-wr-acc]');
    if (!head) return;
    var item = head.closest('.wr-acc__item');
    if (!item) return;
    var group = head.getAttribute('data-wr-acc');
    var open = item.classList.contains('is-open');
    if (group) {
      var root = item.closest('[data-wr-acc-group="' + group + '"]') || document;
      root.querySelectorAll('.wr-acc__item.is-open').forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var h = other.querySelector('[data-wr-acc]');
          if (h) h.setAttribute('aria-expanded', 'false');
        }
      });
    }
    item.classList.toggle('is-open', !open);
    head.setAttribute('aria-expanded', String(!open));
  });

  /* Tastaturbedienung für role="button"-Akkordeonköpfe (Drawer) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var head = e.target.closest('[data-wr-acc][role="button"]');
    if (!head) return;
    e.preventDefault();
    head.click();
  });

  /* Drawer schließen (Scrim / X): über den Summary-Klick von Dawn */
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-wr-drawer-close]');
    if (!closer) return;
    var details = closer.closest('details');
    if (details && details.hasAttribute('open')) {
      var summary = details.querySelector('summary');
      if (summary) summary.click();
    }
  });

  /* ---------- AJAX „In den Warenkorb“ (Karten, PDP) ---------- */
  function cartSectionNames() {
    var names = ['cart-icon-bubble'];
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    if (drawer) names.push('cart-drawer');
    if (notification) names.push('cart-notification-product', 'cart-notification-button');
    return names;
  }

  function refreshCartUi(sections) {
    if (!sections) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-icon-bubble'];
      var inner = tmp.querySelector('.shopify-section') || tmp;
      bubble.innerHTML = inner.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var t = document.createElement('div');
      t.innerHTML = sections['cart-drawer'];
      var newDrawer = t.querySelector('cart-drawer');
      if (newDrawer) {
        drawer.querySelectorAll('.drawer__inner').forEach(function (el, i) {
          var src = newDrawer.querySelectorAll('.drawer__inner')[i];
          if (src) el.innerHTML = src.innerHTML;
        });
        drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      }
      if (typeof drawer.open === 'function') drawer.open();
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-wr-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var data = new FormData(form);
    data.append('sections', cartSectionNames().join(','));
    data.append('sections_url', window.location.pathname);
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.sections) refreshCartUi(res.sections);
        document.dispatchEvent(new CustomEvent('wr:cart:added', { detail: res }));
      })
      .catch(function () {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  });

  /* ---------- Rail mit Pfeilnavigation ---------- */
  var WrRail = class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-rail-scroller]');
      this.prevBtn = this.querySelector('[data-rail-prev]');
      this.nextBtn = this.querySelector('[data-rail-next]');
      if (!this.scroller) return;
      this._measure = this.measure.bind(this);
      this.scroller.addEventListener('scroll', this._measure, { passive: true });
      window.addEventListener('resize', this._measure);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.step.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.step.bind(this, 1));
      this.measure();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this._measure);
    }
    step(dir) {
      this.scroller.scrollBy({ left: dir * Math.round(this.scroller.clientWidth * 0.8), behavior: 'smooth' });
    }
    measure() {
      var el = this.scroller;
      var overflow = el.scrollWidth > el.clientWidth + 4;
      this.classList.toggle('has-overflow', overflow);
      this.classList.toggle('at-start', el.scrollLeft <= 4);
      this.classList.toggle('at-end', el.scrollLeft >= el.scrollWidth - el.clientWidth - 4);
      var anchor = this.querySelector('[data-rail-anchor]');
      if (anchor && anchor.offsetHeight) {
        this.style.setProperty('--wr-arrow-y', Math.round(anchor.offsetHeight / 2) + 'px');
      }
    }
  };
  if (!customElements.get('wr-rail')) customElements.define('wr-rail', WrRail);

  /* ---------- Zähler (Kunden-Counter) ----------
     data-target ist der im Theme gepflegte Rueckfallwert. Mit data-src wird
     zusaetzlich eine Live-Zahl geholt (JSON, Feld "count"). Schlaegt das fehl,
     antwortet die Quelle zu langsam oder liefert sie Unsinn, bleibt der
     Rueckfallwert stehen — auf der Seite steht nie eine 0. */
  var WR_COUNT_CACHE = 'wr:count:';
  var WR_COUNT_TTL = 10 * 60 * 1000;

  function wrCountFromCache(url) {
    try {
      var raw = sessionStorage.getItem(WR_COUNT_CACHE + url);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || Date.now() - o.t > WR_COUNT_TTL) return null;
      return o.n;
    } catch (e) {
      return null;
    }
  }

  function wrCountToCache(url, n) {
    try {
      sessionStorage.setItem(WR_COUNT_CACHE + url, JSON.stringify({ n: n, t: Date.now() }));
    } catch (e) {
      /* privater Modus o. ae. — nicht schlimm */
    }
  }

  function wrFetchCount(url) {
    var cached = wrCountFromCache(url);
    if (cached != null) return Promise.resolve(cached);
    if (!window.fetch) return Promise.resolve(null);

    /* Haengt die Quelle, laeuft die Seite trotzdem weiter. */
    var ctrl = window.AbortController ? new AbortController() : null;
    var abbruch = setTimeout(function () { if (ctrl) ctrl.abort(); }, 4000);

    return fetch(url, { mode: 'cors', credentials: 'omit', signal: ctrl && ctrl.signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return null;
        /* Der Dienst meldet mit source "fallback", dass er selbst noch nie
           eine echte Zahl hatte — dann ist das keine Live-Zahl und zaehlt
           nicht. Sonst koennte ein Platzhalter im Shop landen. */
        if (data.source === 'fallback') return null;
        var n = typeof data === 'number' ? data : data.count;
        n = parseInt(n, 10);
        if (!isFinite(n) || n <= 0) return null;
        wrCountToCache(url, n);
        return n;
      })
      .catch(function () { return null; })
      .then(function (n) { clearTimeout(abbruch); return n; });
  }

  var WrCounter = class extends HTMLElement {
    connectedCallback() {
      var fallback = parseInt(this.getAttribute('data-target') || '0', 10) || 0;
      var el = this;
      var src = this.getAttribute('data-src');
      if (!fallback && !src) return;
      var onlyUp = this.getAttribute('data-only-up') === '1';
      var min = parseInt(this.getAttribute('data-min') || '0', 10) || 0;
      var wrap = this.closest('[data-wr-counter-wrap]');

      var zahl = src
        ? wrFetchCount(src).then(function (n) {
            if (n == null) return fallback;
            if (onlyUp && n < fallback) return fallback;
            return n;
          })
        : Promise.resolve(fallback);

      zahl.then(function (target) {
        /* Unter der Mindestzahl bleibt die Zeile unsichtbar — und ohne
           gueltige Zahl erst recht. */
        if (!target || (min && target < min)) {
          if (wrap) wrap.hidden = true;
          return;
        }
        if (wrap) wrap.hidden = false;
        el.animate_(target);
      });
    }

    animate_(target) {
      var el = this;
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || started) return;
        started = true;
        io.disconnect();
        var t0 = Date.now();
        var dur = 1100;
        var timer = setInterval(function () {
          var k = Math.min(1, (Date.now() - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(target * eased).toLocaleString('de-DE');
          if (k >= 1) clearInterval(timer);
        }, 40);
      }, { threshold: 0.4 });
      io.observe(this);
    }
  };
  if (!customElements.get('wr-counter')) customElements.define('wr-counter', WrCounter);

  /* ---------- Mengen-Stepper ---------- */
  var WrQty = class extends HTMLElement {
    connectedCallback() {
      var target = this.getAttribute('data-target');
      this.input = target
        ? document.querySelector(target)
        : this.querySelector('input[name="quantity"], input[data-qty-input]');
      this.label = this.querySelector('[data-qty-label]');
      var self = this;
      if (target) {
        document.addEventListener('wr:qty', function (e) {
          if (e.target !== self && e.target.getAttribute && e.target.getAttribute('data-target') === target && self.label) {
            self.label.textContent = e.detail.value;
          }
        });
      }
      this.querySelectorAll('[data-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () { self.change(-1); });
      });
      this.querySelectorAll('[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () { self.change(1); });
      });
    }
    get value() {
      return Math.max(1, parseInt((this.input && this.input.value) || '1', 10) || 1);
    }
    change(d) {
      var v = Math.max(1, this.value + d);
      if (this.input) this.input.value = v;
      if (this.label) this.label.textContent = v;
      this.dispatchEvent(new CustomEvent('wr:qty', { detail: { value: v }, bubbles: true }));
    }
  };
  if (!customElements.get('wr-qty')) customElements.define('wr-qty', WrQty);

  /* ---------- AGB-Checkbox vor dem Checkout ----------
     Der Checkout-Button wird serverseitig deaktiviert gerendert, sobald die
     Checkbox aktiv ist. Hier wird er nur wieder freigegeben. Damit stimmt der
     Zustand auch nach jedem Warenkorb-Update (Shopify rendert die Section neu). */
  function wrTermsScope(el) {
    return el.closest('cart-drawer, form[action*="/cart"], .cart__footer, #main-cart-footer, body');
  }

  function wrTermsApply(box) {
    var scope = wrTermsScope(box);
    if (!scope) return;
    var input = box.querySelector('[data-wr-terms-input]');
    if (!input) return;
    var ok = input.checked;

    scope.querySelectorAll('[data-wr-terms-gate]').forEach(function (btn) {
      btn.disabled = !ok;
    });

    if (box.hasAttribute('data-wr-terms-express')) {
      scope.querySelectorAll('[data-wr-terms-express-wrap]').forEach(function (wrap) {
        wrap.classList.toggle('wr-terms-locked', !ok);
      });
    }

    if (ok) {
      box.classList.remove('is-missing');
      var note = box.querySelector('[data-wr-terms-note]');
      if (note) note.hidden = true;
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-wr-terms-input]') : null;
    if (!input) return;
    var box = input.closest('[data-wr-terms]');
    if (box) wrTermsApply(box);
  });

  /* Klick auf den gesperrten Button: Hinweis zeigen, statt stumm zu bleiben.
     Ein deaktivierter Button feuert selbst kein Klick-Ereignis — per CSS
     nimmt er keine Zeiger-Ereignisse an, der Klick landet also im Umfeld. */
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest ? e.target.closest('.cart__ctas') : null;
    if (!wrap) return;
    var btn = wrap.querySelector('[data-wr-terms-gate]');
    if (!btn || !btn.disabled) return;
    var scope = wrTermsScope(wrap);
    var box = scope && scope.querySelector('[data-wr-terms]');
    if (!box) return;
    var note = box.querySelector('[data-wr-terms-note]');
    if (note) note.hidden = false;
    box.classList.add('is-missing');
    var input = box.querySelector('[data-wr-terms-input]');
    if (input && input.focus) input.focus();
  }, true);

  /* Nach jedem Neu-Rendern des Warenkorbs den Zustand neu setzen. */
  function wrTermsInit() {
    document.querySelectorAll('[data-wr-terms]').forEach(wrTermsApply);
  }
  document.addEventListener('DOMContentLoaded', wrTermsInit);
  document.addEventListener('shopify:section:load', wrTermsInit);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-wr-terms]') || n.querySelector('[data-wr-terms]'))) {
            wrTermsInit();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  wrTermsInit();

  /* ---------- PDP: Kaufplan-Auswahl (Einmalkauf / Abo) ---------- */
  document.addEventListener('click', function (e) {
    var plan = e.target.closest('[data-wr-plan]');
    if (!plan) return;
    var scope = plan.closest('[data-wr-pdp]');
    if (!scope) return;
    scope.querySelectorAll('[data-wr-plan]').forEach(function (p) {
      p.classList.toggle('is-active', p === plan);
    });
    var input = scope.querySelector('input[name="selling_plan"]');
    if (input) input.value = plan.getAttribute('data-selling-plan') || '';
    var priceEl = scope.querySelector('[data-wr-price-now]');
    if (priceEl && plan.getAttribute('data-price')) priceEl.textContent = plan.getAttribute('data-price');
    var perday = scope.querySelector('[data-wr-perday]');
    if (perday) {
      var pd = plan.getAttribute('data-perday') || '';
      perday.textContent = pd;
      perday.hidden = !pd;
    }
    var unit = scope.querySelector('[data-wr-unitprice]');
    if (unit) {
      var up = plan.getAttribute('data-unit') || '';
      var upText = unit.querySelector('.price-item') || unit.querySelector('.unit-price');
      if (upText) upText.textContent = up;
      unit.hidden = !up;
    }
    var compare = scope.querySelector('[data-wr-compare]');
    if (compare) {
      var cmp = plan.getAttribute('data-compare') || '';
      compare.textContent = cmp;
      compare.hidden = !cmp;
    }
    scope.querySelectorAll('[data-wr-satc-price]').forEach(function (el) {
      if (plan.getAttribute('data-price')) el.textContent = plan.getAttribute('data-price');
    });
  });

  /* ---------- Bedürfnis-Chips (Featured Collection) ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-wr-need]');
    if (!chip) return;
    var section = chip.closest('.wr-featured');
    if (!section) return;
    var key = chip.getAttribute('data-wr-need');
    section.querySelectorAll('[data-wr-need]').forEach(function (c) {
      c.classList.toggle('is-active', c === chip || c.getAttribute('data-wr-need') === key);
    });
    section.querySelectorAll('[data-wr-need-group]').forEach(function (g) {
      g.hidden = g.getAttribute('data-wr-need-group') !== key;
    });
    var rail = section.querySelector('wr-rail');
    if (rail && rail.scroller) {
      rail.scroller.scrollTo({ left: 0 });
      rail.measure();
    }
  });

  /* ---------- PDP-Galerie: mobile Dots + Desktop-Thumbnails ---------- */
  var WrGallery = class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.scroller = this.querySelector('[data-gal-scroller]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-gal-dot]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gal-thumb]'));
      this.mainSlides = Array.prototype.slice.call(this.querySelectorAll('[data-gal-main]'));

      if (this.scroller) {
        this.scroller.addEventListener('scroll', function () {
          clearTimeout(self._t);
          self._t = setTimeout(self.syncDots.bind(self), 60);
        }, { passive: true });
        this.dots.forEach(function (d, i) {
          d.addEventListener('click', function (e) {
            e.preventDefault();
            var track = self.scroller.firstElementChild;
            var kid = track && track.children[i];
            if (kid) self.scroller.scrollTo({ left: kid.offsetLeft - self.scroller.offsetLeft, behavior: 'smooth' });
          });
        });
      }

      this.thumbs.forEach(function (t) {
        var idx = parseInt(t.getAttribute('data-gal-thumb'), 10);
        t.addEventListener('click', function () { self.select(idx); });
        t.addEventListener('mouseenter', function () { self.select(idx); });
      });
      if (this.thumbs.length) this.select(0);
      this.initThumbPaging();
      this.initZoom();
    }
    /* Max. 6 Thumbnails sichtbar; Pfeil auf dem ersten/letzten steppt durch
       (Export: galThumbs, MAXT = 6). */
    initThumbPaging() {
      var MAXT = 6;
      if (this.thumbs.length <= MAXT) return;
      var self = this;
      this._thOff = 0;
      var render = function () {
        var off = self._thOff;
        self.querySelectorAll('.wr-pdp__thumbstep').forEach(function (b) { b.remove(); });
        self.thumbs.forEach(function (t, i) {
          if (i < off || i >= off + MAXT) t.setAttribute('data-th-hidden', '');
          else t.removeAttribute('data-th-hidden');
        });
        var mkStep = function (dir) {
          var b = document.createElement('span');
          b.className = 'wr-pdp__thumbstep wr-pdp__thumbstep--' + (dir < 0 ? 'up' : 'down');
          b.setAttribute('role', 'button');
          b.setAttribute('aria-label', dir < 0 ? 'Vorherige Bilder' : 'Weitere Bilder');
          b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 9l7 7 7-7"></path></svg>';
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self._thOff = Math.max(0, Math.min(self.thumbs.length - MAXT, self._thOff + dir));
            render();
          });
          return b;
        };
        if (off > 0) self.thumbs[off].appendChild(mkStep(-1));
        if (off + MAXT < self.thumbs.length) self.thumbs[off + MAXT - 1].appendChild(mkStep(1));
      };
      render();
    }
    /* Zoom wie im Export: Desktop nach kurzem Verweilen am Cursor-Punkt,
       mobil per Tap am Tipp-Punkt (erneutes Tippen zoomt heraus). */
    initZoom() {
      var self = this;
      var main = this.querySelector('.wr-pdp__main');
      if (main) {
        main.addEventListener('mousemove', function (e) {
          var slide = main.querySelector('[data-gal-main]:not([hidden])');
          if (!slide) return;
          var img = slide.querySelector('img:not(.wr-card__eff)');
          if (!img) return;
          var r = main.getBoundingClientRect();
          img.style.transformOrigin =
            Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)).toFixed(1) + '% ' +
            Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100)).toFixed(1) + '%';
          if (!slide.classList.contains('is-zoomed') && !self._dwell) {
            self._dwell = setTimeout(function () {
              self._dwell = null;
              slide.classList.add('is-zoomed');
            }, 300);
          }
        });
        main.addEventListener('mouseleave', function () {
          clearTimeout(self._dwell);
          self._dwell = null;
          main.querySelectorAll('.is-zoomed').forEach(function (s) { s.classList.remove('is-zoomed'); });
        });
      }
      this.querySelectorAll('.wr-pdp__slide').forEach(function (slide) {
        slide.addEventListener('click', function (e) {
          var img = slide.querySelector('img:not(.wr-card__eff)');
          if (!img) return;
          if (slide.classList.contains('is-zoomed')) {
            slide.classList.remove('is-zoomed');
            if (self.scroller) self.scroller.style.overflowX = '';
          } else {
            var r = slide.getBoundingClientRect();
            img.style.transformOrigin =
              Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)).toFixed(1) + '% ' +
              Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100)).toFixed(1) + '%';
            slide.classList.add('is-zoomed');
            if (self.scroller) self.scroller.style.overflowX = 'hidden';
          }
        });
      });
    }
    select(i) {
      this.querySelectorAll('.wr-pdp__mainslide.is-zoomed').forEach(function (s) { s.classList.remove('is-zoomed'); });
      this.thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-gal-thumb'), 10) === i);
      });
      this.mainSlides.forEach(function (m) {
        m.hidden = parseInt(m.getAttribute('data-gal-main'), 10) !== i;
      });
    }
    syncDots() {
      if (!this.scroller || !this.dots.length) return;
      var track = this.scroller.firstElementChild;
      if (!track || !track.children.length) return;
      var best = 0;
      var bd = Infinity;
      var sl = this.scroller.scrollLeft;
      Array.prototype.forEach.call(track.children, function (k, i) {
        var d = Math.abs(k.offsetLeft - sl);
        if (d < bd) { bd = d; best = i; }
      });
      this.dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === best);
      });
    }
  };
  if (!customElements.get('wr-gallery')) customElements.define('wr-gallery', WrGallery);

  /* ---------- Sticky Add-to-Cart (PDP) ----------
     Mobil: 3 Zustände — kompakt (nur Button) · versteckt (echter Button
     sichtbar) · voll (Button + Infozeile). Desktop: Mini-Karte unten rechts. */
  /* ---------- Fade-Rotation (Bestseller-Karte, Home) ---------- */
  var WrFade = class extends HTMLElement {
    connectedCallback() {
      var slides = this.querySelectorAll('.wr-fade__slide');
      if (slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var iv = (parseFloat(this.getAttribute('data-interval')) || 5) * 1000;
      var self = this;
      this._i = 0;
      this._t = setInterval(function () {
        self._i = (self._i + 1) % slides.length;
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', j === self._i);
        });
      }, iv);
    }
    disconnectedCallback() {
      if (this._t) clearInterval(this._t);
    }
  };
  if (!customElements.get('wr-fade')) customElements.define('wr-fade', WrFade);

  var WrStickyAtc = class extends HTMLElement {
    connectedCallback() {
      var anchorSel = this.getAttribute('data-anchor');
      this.anchor = anchorSel ? document.querySelector(anchorSel) : null;
      if (!this.anchor) return;
      this.footer = document.querySelector('.wr-footer, footer');
      this._onScroll = this.update.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
    update() {
      var b = this.anchor.getBoundingClientRect();
      var vh = window.innerHeight;

      /* Popup bleibt sichtbar, scrollt aber nicht ueber den Footer:
         sobald der Footer ins Bild kommt, dockt es an dessen Oberkante an. */
      var dock = 0;
      if (this.footer) {
        var ft = this.footer.getBoundingClientRect().top;
        if (ft < vh) dock = vh - ft;
      }
      if (dock !== this._dock) {
        this._dock = dock;
        this.style.setProperty('--wr-satc-dock', dock + 'px');
      }

      var mode;
      if (b.bottom < 0) {
        mode = 'full';
      } else {
        var bar = this.bar || (this.bar = this.querySelector('.wr-satc'));
        var mobileBar = bar && getComputedStyle(bar).display !== 'none';
        if (mobileBar) {
          /* Export-Verhalten: Umschalten genau dann, wenn der echte Button
             die Button-Position der Leiste erreicht (untransformierte Lage:
             fixed an der Viewport-Unterkante minus Footer-Dock). */
          if (this._barPadB == null) this._barPadB = parseFloat(getComputedStyle(bar).paddingBottom) || 0;
          var barBtnBottom = vh - dock - this._barPadB;
          mode = b.bottom <= barBtnBottom + 1 ? 'hidden' : 'compact';
        } else {
          mode = b.top < vh - 24 ? 'hidden' : 'compact';
        }
      }
      if (mode !== this._mode) {
        /* Slide nur beim Wechsel mit dem Info-Zustand; kompakt<->versteckt
           wird hart getauscht — der Button steht dann an derselben Position
           und verliert visuell nur seinen Rahmen. */
        var slide = mode === 'full' || this._mode === 'full';
        this.setAttribute('data-anim', slide ? 'slide' : 'none');
        this._mode = mode;
        this.setAttribute('data-mode', mode);
      }
    }
  };
  if (!customElements.get('wr-sticky-atc')) customElements.define('wr-sticky-atc', WrStickyAtc);
})();

/* sync: 2026-08-24 Redesign-Neuübertragung */
